/* TN Video Reviews — regelt afspeelgedrag voor de UGC video-testimonials.
   Instellingen komen via data-attributen op [data-tnvt] uit de theme-editor:
   autoplay, loop, muted (start zonder geluid), controls (pauzeknop), sound-toggle.
   Idempotent: veilig om meerdere keren te laden en bij shopify:section:load. */
(function () {
  if (window.__tnvtInit) return;
  window.__tnvtInit = true;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function attr(el, name, def) {
    var v = el.getAttribute(name);
    if (v === null || v === '') return def;
    return v === 'true';
  }

  function setMutedState(card, video) {
    if (video.muted) {
      card.classList.add('is-muted');
      card.classList.remove('is-unmuted');
    } else {
      card.classList.add('is-unmuted');
      card.classList.remove('is-muted');
    }
  }

  function muteOthers(wrap, keep) {
    wrap.querySelectorAll('.tnvt__video').forEach(function (v) {
      if (v !== keep && !v.muted) {
        v.muted = true;
        var c = v.closest('.tnvt__card');
        if (c) setMutedState(c, v);
      }
    });
  }

  function initWrap(wrap) {
    if (wrap.__tnvtDone) return;
    wrap.__tnvtDone = true;

    // Auto-hide op de live storefront wanneer er geen enkele video is (voorkomt
    // een leeg blok/kop). Werkt overal — geen :has()-CSS nodig.
    var hasVideo = wrap.querySelector('.tnvt__video');
    if (!hasVideo && wrap.getAttribute('data-autohide') === 'true') {
      wrap.style.display = 'none';
      return;
    }

    var autoplay = attr(wrap, 'data-autoplay', true);
    var loop = attr(wrap, 'data-loop', true);
    var startMuted = attr(wrap, 'data-muted', true);
    var showControls = attr(wrap, 'data-controls', false);
    var soundToggle = attr(wrap, 'data-sound-toggle', true);

    var cards = wrap.querySelectorAll('.tnvt__card');

    cards.forEach(function (card) {
      var video = card.querySelector('.tnvt__video');
      if (!video) return;

      video.loop = loop;
      video.muted = startMuted;
      video.playsInline = true;
      video.setAttribute('playsinline', '');

      if (showControls) {
        video.controls = true;
      } else {
        video.controls = false;
        video.removeAttribute('controls');
      }

      setMutedState(card, video);

      // Sound toggle button
      var soundBtn = card.querySelector('.tnvt__sound');
      if (soundBtn) {
        if (showControls || !soundToggle) {
          soundBtn.style.display = 'none';
        } else {
          soundBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (video.muted) {
              muteOthers(wrap, video); // maar één video met geluid tegelijk
              video.muted = false;
              try { video.volume = 1; } catch (err) {}
              video.play().catch(function () {});
            } else {
              video.muted = true;
            }
            setMutedState(card, video);
          });
          video.addEventListener('volumechange', function () {
            setMutedState(card, video);
          });
        }
      }

      // Play/pause overlay
      var playBtn = card.querySelector('.tnvt__play');
      if (playBtn) {
        playBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (video.paused) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      }
      video.addEventListener('play', function () {
        card.classList.remove('is-paused');
      });
      video.addEventListener('pause', function () {
        card.classList.add('is-paused');
      });

      if (!autoplay || reduceMotion) {
        card.classList.add('is-paused');
      }
    });

    // Autoplay wanneer in beeld, pauzeer wanneer uit beeld (bespaart data/CPU)
    if (autoplay && !reduceMotion && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            var video = en.target;
            if (en.isIntersecting && en.intersectionRatio >= 0.4) {
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: [0, 0.4, 0.75] }
      );
      wrap.querySelectorAll('.tnvt__video').forEach(function (v) {
        io.observe(v);
      });
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-tnvt]').forEach(initWrap);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  }

  // Theme-editor: opnieuw initialiseren wanneer een sectie/blok herlaadt
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var v = e.target && e.target.querySelector && e.target.querySelector('.tnvt__video');
    if (v) v.play().catch(function () {});
  });
})();
